<template>
    <div class="home-container">
        <!-- 轮播 Banner -->
        <!-- <el-carousel
            class="banner-carousel"
            :interval="5000"
            :arrow="showControls ? 'always' : 'never'"
            :indicator-position="showIndicators ? 'outside' : 'none'"
        >
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item.image" class="banner-image" alt="FOGO" />
            </el-carousel-item>
        </el-carousel> -->
        <div class="banner-carousel">
            <img :src="bannerList[0].image" class="banner-image" alt="FOGO" />
        </div>

        <!-- 套餐列表 -->
        <div class="package-container">
            <!-- 单设备套餐 -->
            <div class="package-section">
                <h2 class="section-title">{{ $t('singleDevice') }}</h2>
                <el-row :gutter="gutterSize">
                    <el-col
                        v-for="item in singleDevicePlans"
                        :key="item.goodsId"
                        :xs="12"
                        :sm="12"
                        :md="8"
                        :lg="6"
                        class="package-col"
                    >
                        <div v-if="item.discountRatio" class="discount-badge">
                            {{ $t('about') }}&nbsp;{{ item.discountRatio }}% OFF
                        </div>
                        <el-card shadow="hover" class="plan-card">
                            <div slot="header" class="plan-header">
                                <span>{{ item.goodsName }}</span>
                            </div>
                            <div class="plan-price">
                                <span class="price-title"
                                    >{{ $t('price') }}:</span
                                >
                                <span class="original-price">
                                    {{ item.goodsAmountCcy }}&nbsp;{{
                                        Number(
                                            item.goodsOriginalAmount
                                        ).toFixed(2)
                                    }}
                                </span>
                                <span class="price">
                                    {{ item.goodsAmountCcy }}&nbsp;{{
                                        Number(item.goodsAmount).toFixed(2)
                                    }}
                                </span>
                            </div>
                            <div class="plan-price">
                                <span
                                    class="avg-price"
                                    v-if="item.goodsAverageAmount"
                                    >{{ $t('Average') }}&nbsp;{{
                                        item.goodsAmountCcy
                                    }}&nbsp;{{
                                        Number(item.goodsAverageAmount).toFixed(
                                            2
                                        )
                                    }}{{ $t('monthly') }}</span
                                >
                            </div>
                            <el-button
                                @click="handleSelect(item)"
                                :loading="upgradeLoading"
                                style="
                                    background-color: #ee3769;
                                    color: #ffffff;
                                "
                                >{{ $t('buyNow') }}</el-button
                            >
                            <div
                                class="plan-details"
                                v-html="item.goodsDescription"
                            ></div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>

            <!-- 双设备套餐 -->
            <div class="package-section">
                <h2 class="section-title">{{ $t('dualDevice') }}</h2>
                <el-row :gutter="gutterSize">
                    <el-col
                        v-for="item in dualDevicePlans"
                        :key="item.goodsId"
                        :xs="12"
                        :sm="12"
                        :md="8"
                        :lg="6"
                        class="package-col"
                    >
                        <div v-if="item.discountRatio" class="discount-badge">
                            {{ $t('about') }}&nbsp;{{ item.discountRatio }}% OFF
                        </div>
                        <el-card shadow="hover" class="plan-card">
                            <div slot="header" class="plan-header">
                                <span>{{ item.goodsName }}</span>
                            </div>
                            <div class="plan-price">
                                <span class="price-title"
                                    >{{ $t('price') }}:</span
                                >
                                <span class="original-price">
                                    {{ item.goodsAmountCcy }}&nbsp;{{
                                        Number(
                                            item.goodsOriginalAmount
                                        ).toFixed(2)
                                    }}
                                </span>
                                <span class="price">
                                    {{ item.goodsAmountCcy }}&nbsp;{{
                                        Number(item.goodsAmount).toFixed(2)
                                    }}
                                </span>
                            </div>
                            <div class="plan-price">
                                <span
                                    class="avg-price"
                                    v-if="item.goodsAverageAmount"
                                    >{{ $t('Average') }}&nbsp;{{
                                        item.goodsAmountCcy
                                    }}&nbsp;{{
                                        Number(item.goodsAverageAmount).toFixed(
                                            2
                                        )
                                    }}{{ $t('monthly') }}</span
                                >
                            </div>
                            <el-button
                                @click="handleSelect(item)"
                                :loading="upgradeLoading"
                                style="
                                    background-color: #ee3769;
                                    color: #ffffff;
                                "
                                >{{ $t('buyNow') }}</el-button
                            >
                            <div
                                class="plan-details"
                                v-html="item.goodsDescription"
                            ></div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 支付弹窗 -->
        <el-dialog
            :title="$t('scanToPay')"
            :visible.sync="paymentDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            center
        >
            <div class="payment-dialog-content">
                <div class="payment-info-item">
                    <span class="payment-label">{{ $t('planType') }}:</span>
                    <span class="payment-value">{{ selectedPlanName }}</span>
                </div>
                <div class="payment-info-item">
                    <span class="payment-label">{{ $t('amount') }}:</span>
                    <span class="payment-value"
                        >{{ selectedPlanCurrency }}
                        {{ selectedPlanAmount }}</span
                    >
                </div>
                <div class="qr-code-container">
                    <p class="qr-code-tip">{{ $t('scanQrCode') }}</p>
                    <QrcodeVue
                        v-if="qrCodeLink"
                        :value="qrCodeLink"
                        :size="200"
                        level="H"
                        class="qr-code-image"
                    />
                    <div v-else class="qr-code-loading">
                        {{ $t('paymentConfirming') }}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="handlePaymentCompleted"
                    style="background-color: #ee3769; border-color: #ee3769"
                >
                    {{ $t('paymentCompleted') }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getPlanList, getOrderToken, createOrder } from '@/api/order'
import { createErrorHandler } from '@/utils/errorHandler'
import { ssoLogin } from '@/api/user'
import QrcodeVue from 'qrcode.vue'
export default {
    components: {
        QrcodeVue
    },
    data() {
        return {
            planList: [],
            token: '',
            selectPlanObj: '',
            upgradeLoading: false,
            gutterSize: 40,
            paymentDialogVisible: false,
            qrCodeLink: '',
            selectedPlanName: '',
            selectedPlanAmount: '',
            selectedPlanCurrency: ''
        }
    },
    async mounted() {
        this.errorHandler = createErrorHandler(this)
        this.updateGutterSize()
        window.addEventListener('resize', this.updateGutterSize)
        await this.handleUrlParams()
        this.getAllPlanList()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateGutterSize)
    },
    computed: {
        // 单设备套餐：goodsId 1/2/3/4
        singleDevicePlans() {
            return this.planList.filter((item) => {
                const id = item.goodsId
                return id === 1 || id === 2 || id === 3 || id === 4
            })
        },
        // 双设备套餐：goodsId 不为 1/2/3/4
        dualDevicePlans() {
            return this.planList.filter((item) => {
                const id = item.goodsId
                return id !== 1 && id !== 2 && id !== 3 && id !== 4
            })
        },
        bannerList() {
            const isPortuguese = this.$i18n.locale.startsWith('pt')
            return [
                {
                    image: require('@/assets/img/' +
                        (isPortuguese
                            ? 'banner-pt-new.png'
                            : 'banner-en-new.png'))
                }
            ]
        },
        showControls() {
            return this.bannerList.length > 1
        },
        showIndicators() {
            return this.bannerList.length > 1
        }
    },
    methods: {
        updateGutterSize() {
            this.gutterSize = window.innerWidth <= 768 ? 12 : 40
        },
        handleUrlParams() {
            const { authCode, lang, tab } = this.$route.query
            if (lang) {
                this.$i18n.locale = lang
                localStorage.setItem('locale', lang)
            }
            if (tab) {
                // tab 参数预留，后续可按需使用
            }
            if (authCode) {
                return ssoLogin({ ticket: authCode })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$store.dispatch('login', res.data)
                            this.$router.replace({ query: {} })
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        }
                    })
                    .catch((err) => console.log(err))
            }
            return Promise.resolve()
        },
        handleSelect(item) {
            this.selectPlanObj = item
            this.upgradeLoading = true
            this.selectedPlanName = item.goodsName
            this.selectedPlanAmount = Number(item.goodsAmount).toFixed(2)
            this.selectedPlanCurrency = item.goodsAmountCcy
            this.getCreateOrderToken()
        },
        // 获取生成订单token
        getCreateOrderToken() {
            getOrderToken({
                goodsId: this.selectPlanObj.goodsId
            })
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.token = res.data
                        this.createOrder()
                    } else {
                        this.upgradeLoading = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.upgradeLoading = false
                })
        },
        // 创建订单
        createOrder() {
            createOrder({
                goodsId: this.selectPlanObj.goodsId,
                orderToken: this.token
            })
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.qrCodeLink = res.data.paymentQrCode
                        this.paymentDialogVisible = true
                    }
                    this.upgradeLoading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.upgradeLoading = false
                })
        },
        // 处理支付完成
        handlePaymentCompleted() {
            this.paymentDialogVisible = false
            this.qrCodeLink = ''
            this.selectedPlanName = ''
            this.selectedPlanAmount = ''
            this.selectedPlanCurrency = ''
            this.$router.push('/account')
        },
        getAllPlanList() {
            getPlanList()
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.planList = res.data
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped>
.home-container {
    /* max-width: 1200px; */
    margin: 0 auto;
}

/* Banner 样式 */
.banner-carousel {
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    /* height: 100%; */
    /* object-fit: cover; */
}

.banner-title {
    position: absolute;
    left: 50px;
    bottom: 60px;
    color: #fff;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

.banner-title h2 {
    font-size: 32px;
    margin-bottom: 10px;
}

.banner-title p {
    font-size: 18px;
}

/* 自定义指示器样式 */
::v-deep .el-carousel__indicator button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
}

::v-deep .el-carousel__indicator.is-active button {
    background-color: #409eff;
}

::v-deep .el-carousel__arrow {
    background-color: rgba(255, 255, 255, 0.8);
    color: #333;
}

::v-deep .el-carousel__arrow:hover {
    background-color: rgba(255, 255, 255, 0.9);
}
.package-container {
    padding: 0 50px;
}

/* 套餐分区 */
.package-section {
    margin-bottom: 40px;
}

.section-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ee3769;
}

/* 套餐卡片样式 */
.package-card {
    margin-bottom: 20px;
    transition: transform 0.3s;
    position: relative;
}

.package-card:hover {
    transform: translateY(-5px);
}

.package-info {
    padding: 15px;
}

.package-title {
    font-size: 18px;
    margin-bottom: 10px;
    color: #333;
}

.package-desc {
    font-size: 14px;
    color: #666;
    height: 40px;
    overflow: hidden;
    margin-bottom: 15px;
}

.price-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.package-col {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
}
.package-col:hover {
    transform: translateY(-5px);
}
.plan-card {
    margin-bottom: 20px;
    text-align: center;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}
/* 卡片内容区撑满，按钮和描述推到底部 */
.plan-card ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.plan-card ::v-deep .el-card__body .el-button {
    margin-top: auto;
}
/* .plan-card:hover {
    transform: translateY(-5px);
} */

.plan-header {
    font-size: 18px;
    color: #ff4d4f;
    font-weight: bold;
}

.plan-price {
    /* font-size: 24px; */
    margin: 10px 0;
    min-height: 21px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.price-title {
    font-size: 20px;
    font-weight: bold;
}
.price {
    font-weight: bold;
    display: block;
}

.original-price {
    font-size: 14px;
    color: #ff6b6b;
    font-weight: bold;
    text-decoration: line-through;
    margin: 4px auto;
    display: block;
}

.unit {
    font-size: 14px;
}

.avg-price {
    font-size: 14px;
    color: #999;
}

.plan-details {
    list-style-type: none;
    padding: 0;
    margin-top: 12px;
    text-align: left;
    flex-shrink: 0;
}

.plan-details li {
    margin: 5px 0;
    font-size: 14px;
}

.plan-footer {
    text-align: center;
    margin-top: 20px;
}
.discount-badge {
    position: absolute;
    top: -12px;
    right: -10px;
    background-color: #ff3f15;
    color: white;
    border-radius: 50%;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
}

/* 支付弹窗样式 */
.payment-dialog-content {
    text-align: center;
}

.payment-info-item {
    margin: 15px 0;
    font-size: 16px;
}

.payment-label {
    font-weight: bold;
    color: #333;
    margin-right: 10px;
}

.payment-value {
    color: #666;
}

.qr-code-container {
    margin: 20px 0;
}

.qr-code-tip {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
}

.qr-code-image {
    display: inline-block;
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
}

.qr-code-loading {
    color: #999;
    font-size: 14px;
    padding: 40px 0;
}

.dialog-footer {
    text-align: center;
}
/* 移动端适配 */
@media (max-width: 768px) {
    .package-container {
        padding: 0 10px;
    }

    .banner-carousel {
        margin-bottom: 12px;
    }

    .banner-image {
        max-height: 160px;
    }

    .banner-title {
        left: 20px;
        bottom: 30px;
    }

    .banner-title h2 {
        font-size: 18px;
    }

    .banner-title p {
        font-size: 14px;
    }

    /* 分区标题 - 移动端缩小 */
    .section-title {
        font-size: 17px;
        margin-bottom: 10px;
        padding-bottom: 6px;
    }

    .package-section {
        margin-bottom: 16px;
    }

    /* 卡片样式 - 移动端紧凑化 */
    .plan-card {
        margin-bottom: 10px;
    }

    .plan-card ::v-deep .el-card__header {
        padding: 8px 10px;
    }

    .plan-card ::v-deep .el-card__body {
        padding: 8px 10px;
    }

    .plan-header {
        font-size: 14px;
    }

    .plan-price {
        margin: 4px 0;
        min-height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .price-title {
        font-size: 13px;
    }

    .price {
        font-size: 14px;
    }

    .original-price {
        font-size: 11px;
    }

    .avg-price {
        font-size: 11px;
    }

    /* 购买按钮 - 移动端缩小 */
    .plan-card .el-button {
        padding: 6px 12px;
        font-size: 12px;
    }

    /* 套餐描述 - 移动端限制高度保证卡片等高 */
    .plan-details {
        margin-top: 8px;
        font-size: 11px;
        max-height: 80px;
        overflow: hidden;
    }

    .plan-details ::v-deep li {
        font-size: 11px;
        margin: 2px 0;
    }

    .package-title {
        font-size: 16px;
    }

    .package-desc {
        font-size: 13px;
        height: 36px;
    }

    .discount-badge {
        top: -6px;
        right: 6px;
        padding: 3px 6px;
        font-size: 10px;
    }
}
</style>
